export default {
    props: {
        asyncAutoUpload: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.autoUpload'
        }, 
        asyncBatch: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.batch'
        }, 
        asyncChunkSize: {
            type: Number,
            default: undefined,
            kComposite: 'async.chunkSize'
        }, 
        asyncConcurrent: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.concurrent'
        }, 
        asyncAutoRetryAfter: {
            type: Number,
            default: undefined,
            kComposite: 'async.autoRetryAfter'
        }, 
        asyncMaxAutoRetries: {
            type: Number,
            default: undefined,
            kComposite: 'async.maxAutoRetries'
        }, 
        asyncRemoveField: {
            type: String,
            default: undefined,
            kComposite: 'async.removeField'
        }, 
        asyncRemoveUrl: {
            type: String,
            default: undefined,
            kComposite: 'async.removeUrl'
        }, 
        asyncRemoveVerb: {
            type: String,
            default: undefined,
            kComposite: 'async.removeVerb'
        }, 
        asyncSaveField: {
            type: String,
            default: undefined,
            kComposite: 'async.saveField'
        }, 
        asyncSaveUrl: {
            type: String,
            default: undefined,
            kComposite: 'async.saveUrl'
        }, 
        asyncUseArrayBuffer: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.useArrayBuffer'
        }, 
        asyncWithCredentials: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.withCredentials'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/Async.js